import React from 'react';
import ModalLoader from '../modal/modal_loader';
import axios from '../axios';

const History = ({
  props,
  events,
  setHistoryEventId,
  setPage,
  setEvent,
  setEventsPlans,
  setContents,
  setBodyText,
}) => {
  const modalLoaderRef = React.useRef(null);
  const copyEvent = React.useCallback((historyEventId) => {
    modalLoaderRef.current.openModal();
    const body = JSON.stringify({
      event_id: props.event.id,
      circle_id: props.circle.id,
      history_event_id: historyEventId,
    });
    axios
      .post('/api/event/replace_event_from_history', body)
      .then((response) => {
        setHistoryEventId(historyEventId);
        setEvent((prev) => ({ ...prev, ...JSON.parse(response.data.event) }));
        setEventsPlans(JSON.parse(response.data.events_plans));
        const contents = JSON.parse(response.data.contents);
        setContents(contents);
        const textContent = contents.find((content) => content.content_type === 1)
        if (textContent) {
          setBodyText(textContent.body);
        }
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
        setPage(0);
      });
  }, []);

  return (
    <div>
      <div className="container col-md-8 col-lg-6">
        <h6 className="h6--list-title text-fz-14px text-black-50">
          過去のイベントリスト
        </h6>
      </div>
      <div
        className="bg-white mb-3_5"
        style={{ paddingBottom: '200px' }}
      >
        <div className="container col-md-8 col-lg-6">
          <div className="container">
            {events.map((event) => (
              <div className="row py-2 border-bottom" key={event.id}>
                <div className="col-7 pl-0">
                  <p className="tex-fz-12px font-weight-normal text-gray ml-0 mt-2 mb-1">
                    {event.event_date_include_year}
                  </p>
                </div>
                <div className="col-5 pr-0">
                  <button
                    className="a-button a-button--sm a-button--orange mx-0 mb-1 float-right"
                    onClick={() => copyEvent(event.id)}
                  >
                    コピー
                  </button>
                </div>
                <div>
                  <p className="font-weight-normal tex-fz-14px mb-0">{event.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="fixed-bottom mb-3">
        <div className="container col-md-8 col-lg-6">
          <div className="d-flex justify-content-around">
            <button
              type="button"
              className="a-button a-button__top a-button__top--outline mr-2 mb-2 w-100"
              onClick={() => setPage(0)}
            >
              戻る
            </button>
          </div>
        </div>
      </div>
      <ModalLoader ref={modalLoaderRef} />
    </div>
  );
};

export default History;
